import React from 'react';
import clsx from 'clsx';
import {
    MenuItem,
    Menu,
    ClickAwayListener,
} from "@material-ui/core";

/** 
 * @param {[][]} props.component - 2d array  which contains for every row of a form the inside components
 * @param {setState} props.setComponents - hook method that handle components variable
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a form
 * @returns component with a dropdown button that adds components to examined row of a form
 */
const AddInsideComponent = (props) => {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex
    } = props;

    const [clickedAddElement, setClickedAddElement] = React.useState(false); // variable to open/close dropdown menu
    const [anchorEl, setAnchorEl] = React.useState(); // anchor element of dropdown button
    const ElementTypes = ['label', 'input', 'checkbox', 'textarea','button','dropdown','radio']; // component type options to add

    // open dropdown menu
    const buttonfunction = (event) => {
        setClickedAddElement(true);
        setAnchorEl(event.currentTarget);
    }

    // close dropdown menu
    const closeMenu = () => {
        setClickedAddElement(false);
        setAnchorEl(null)
    }

    /**
     * @param {string} option - type of form row to add
     * @returns methods that add type of form row to existing form rows
     */
    const addElement = (option) => {

        const tempComponents = [...components]; // copy components
        const tempTypeFields = [...typeFields]; // copy typeFields
        
        // check type of selected row
        if(option === 'input'){
            // add selected component to existing components
            tempComponents[formRowIndex].push(
                {
                    type: 'input',
                    placeholder: ' Input Name',
                    inputType: 'text',
                    required: false
               }
            )
            // add selected type row to existing type of rows 
            tempTypeFields[formRowIndex].push(
                'input'
            )    
        }
        else if(option === 'label'){
            tempComponents[formRowIndex].push(
                {
                    labelName: 'Name',
                }, 
            )
            tempTypeFields[formRowIndex].push(
                'label'
            )
        }
        else if(option === 'checkbox'){
            tempComponents[formRowIndex].push(
                {
                    checked: false
                }
            )
            tempTypeFields[formRowIndex].push(
                'checkbox'
            )
        }
        else if(option === 'radio'){
            tempComponents[formRowIndex].push({
                labels: ['M', 'F']
            })
            tempTypeFields[formRowIndex].push(
                'radio'
            )
        }
        else if(option === 'textarea'){
            
            tempComponents[formRowIndex].push(
                {
                    placeholder: 'Textarea message',
                    required: false
                }
            )
            tempTypeFields[formRowIndex].push(
                'textarea'
            )
        }
        else if(option === 'button'){
            tempComponents[formRowIndex].push(
                {
                    label: 'Send',
                    method: 'GET',
                    target_page: 'none',
                    href: ''
                }
            )
            tempTypeFields[formRowIndex].push(
                'button'
            )
        }
        else if(option === 'dropdown'){
            tempComponents[formRowIndex].push({
                label: 'Dropdown button',
                options: ['Link1', 'Link2'] 
            })
            tempTypeFields[formRowIndex].push(
                'dropdown'
            )
        }

        setComponents(tempComponents); // update components with selected component 
        setTypeFields(tempTypeFields); // update typeFields with selected type of row
    }

    return(
        <>
            <span 
                className={clsx('teamSelector', 'spacingDownDiv')} 
                onClick={(event) => buttonfunction(event)}
                style={{ display: 'inline-block'}}
                aria-hidden="true"
            >
                <span 
                    style={{fontSize: '0.7vw'}}
                    className={clsx('lightBlue')}>
                        Add new element &nbsp;
                    </span>
            
                {clickedAddElement === false  ? 
                    <i className={clsx('fa', 'fa-caret-down', 'fa-caret-down3')}> </i>
                    : 
                    <ClickAwayListener 
                        onClickAway ={closeMenu}
                    >
                        <i className={clsx('fa', 'fa-caret-up', 'fa-caret-up3', 'teamSelector')} />
                    </ClickAwayListener>
                }    
            </span>
            <Menu   
                elevation={0}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                keepMounted
                open={clickedAddElement}
                >   
                    {
                        ElementTypes.map((option) => (
                            <MenuItem 
                                key={option}
                                onClick ={() => addElement(option)}
                            > 
                                {option}
                            </MenuItem>
                        ))
                    }
            </Menu>
        </>
    )
}

export default AddInsideComponent;